import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import { AssetClassesProvider } from "@/lib/assetClasses";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Dashboard from "@/pages/Dashboard";
import Assets from "@/pages/Assets";
import AssetDetail from "@/pages/AssetDetail";
import AddAsset from "@/pages/AddAsset";
import HomeComponents from "@/pages/HomeComponents";
import Maintenance from "@/pages/Maintenance";
import Vault from "@/pages/Vault";
import HeirsView from "@/pages/HeirsView";
import Walkthrough from "@/pages/Walkthrough";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Onboarding from "@/pages/Onboarding";
import Households from "@/pages/Households";
import AssetClassesSettings from "@/pages/AssetClassesSettings";
import HouseholdDetail from "@/pages/HouseholdDetail";
import InvitationAccept from "@/pages/InvitationAccept";
import Help from "@/pages/Help";
import TransitionGuide from "@/pages/TransitionGuide";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AssetClassesProvider>
          <Toaster
            position="bottom-right"
            theme="light"
            toastOptions={{
              style: {
                background: "#FFFFFF",
                border: "1px solid #E0DDD6",
                borderRadius: "2px",
                fontFamily: "'General Sans', sans-serif",
                color: "#0A192F",
              },
            }}
          />
          <Routes>
            {/* Public */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/heirs/:token" element={<HeirsView />} />
            <Route path="/invitations/:token" element={<InvitationAccept />} />

            {/* Protected */}
            <Route element={<ProtectedRoute />}>
              <Route path="/onboarding" element={<Onboarding />} />
              <Route element={<Layout />}>
                <Route path="/" element={<Dashboard />} />
                <Route path="/assets" element={<Assets />} />
                <Route path="/assets/new" element={<AddAsset />} />
                <Route path="/assets/:id" element={<AssetDetail />} />
                <Route path="/walkthrough" element={<Walkthrough />} />
                <Route path="/home" element={<HomeComponents />} />
                <Route path="/maintenance" element={<Maintenance />} />
                <Route path="/vault" element={<Vault />} />
                <Route path="/households" element={<Households />} />
                <Route path="/households/:id" element={<HouseholdDetail />} />
                <Route path="/settings/classes" element={<AssetClassesSettings />} />
                <Route path="/transition" element={<TransitionGuide />} />
                <Route path="/help" element={<Help />} />
              </Route>
            </Route>
          </Routes>
          </AssetClassesProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
